import { Button } from "@/components/ui/button";
import { CalendarClock, Loader2, Wallet } from "lucide-react";

// Release day 8:00 AM WAT (UTC+1), shown in the viewer's local time.
export const launchOpensAt = (releaseDate) => (releaseDate ? new Date(`${String(releaseDate).slice(0, 10)}T08:00:00+01:00`) : null);
export const launchLabel = (releaseDate) => {
  const d = launchOpensAt(releaseDate);
  return d ? d.toLocaleString(undefined, { weekday: "short", day: "numeric", month: "long", hour: "numeric", minute: "2-digit" }) : "release day, 8:00 AM WAT";
};

export default function LaunchPartyBanner({ state, releaseDate, busy, canWallet, priceLabel, onPay }) {
  const reserved = state.status !== "scheduled";
  return (
    <div className="rounded-xl border border-sky-400/30 bg-sky-500/5 p-4 space-y-3" data-testid="launch-party-banner" data-status={state.status}>
      <p className="flex items-start gap-2 text-sm">
        <CalendarClock className="w-4 h-4 mt-0.5 text-sky-300 shrink-0" />
        <span>
          Opens automatically on <strong>{launchLabel(releaseDate)}</strong> (8:00 AM WAT) — share the link now so guests are ready.
          {reserved ? " Reserved: pay any time before then, or when we email you on release morning." : " Paid ✓ — the 24-hour window starts when it opens."}
        </span>
      </p>
      {reserved && (
        <div className="flex flex-wrap gap-2">
          {canWallet && (
            <Button size="sm" onClick={() => onPay(true)} disabled={busy} className="bg-gold text-ink hover:bg-gold/90" data-testid="launch-pay-wallet-btn">
              {busy ? <Loader2 className="w-3.5 h-3.5 animate-spin" /> : <Wallet className="w-3.5 h-3.5" />} Pay {priceLabel} from wallet
            </Button>
          )}
          <Button size="sm" onClick={() => onPay(false)} disabled={busy} className="bg-terracotta hover:bg-ember text-white" data-testid="launch-pay-card-btn">
            Pay {priceLabel}{canWallet ? " with card" : ""}
          </Button>
        </div>
      )}
    </div>
  );
}
